module.exports = __webpack_public_path__ + "img/scan.05fb11f3.png";